/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./edit-creative.vue?vue&type=template&id=68c039e2&scoped=true&"
import script from "./edit-creative.vue?vue&type=script&lang=js&"
export * from "./edit-creative.vue?vue&type=script&lang=js&"
import style0 from "./edit-creative.vue?vue&type=style&index=0&id=68c039e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c039e2",
  null
  
)

export default component.exports